import { createSlice } from '@reduxjs/toolkit';
import { API } from 'api';
import { getUIVersion } from 'utils/router-static-data';

const initialState = {
	statesWithCites: {},
	cities: [],
};

export const approvalSlice = createSlice({
	name: 'AirExpensesState',
	initialState,
});

export const getapprovalList =
	({ limit, offset = 0, currentPage, trip_approval_status, trip_status, query_str, ...rest }) =>
	async () => {
		console.log(offset);
		const isV2UI = getUIVersion() === 'new';
		const CREDENTIALS = {
			url: '/search',
			// showLoading: false,
			data: {
				search_type: 'approval_entities',
				filter_by: {
					entity_type: ['trip'],
					trip_approval_status,
					trip_status,
					query_str,
					...rest,
				},
				limit,
				offset,
			},
			version: isV2UI ? 'v2' : undefined,
		};

		return API.common(CREDENTIALS).then(async (response) => {
			// Transform v2 response to v1 format for component compatibility
			if (isV2UI) {
				const { transformApprovalListResponseV2ToV1 } = await import(
					'../utils/approvalV2Transformations'
				);
				return transformApprovalListResponseV2ToV1(response);
			}

			// v1 response format (unchanged)
			return {
				rows: response?.data,
				count: response?.meta?.count,
			};
		});
	};
export const getPodList =
	({ limit, offset = 0, ...rest }) =>
	async () => {
		const isV2UI = getUIVersion() === 'new';
		const CREDENTIALS = {
			url: '/search',
			// showLoading: false,
			data: {
				search_type: 'proof_of_delivery',
				filter_by: {
					...rest,
				},
				limit,
				offset,
			},
			version: isV2UI ? 'v2' : undefined,
		};

		return API.common(CREDENTIALS).then(async (response) => {
			// Transform v2 response to v1 format for component compatibility
			if (isV2UI) {
				const { transformPodListResponseV2ToV1 } = await import(
					'../utils/approvalV2Transformations'
				);
				return transformPodListResponseV2ToV1(response);
			}

			// v1 response format (unchanged)
			return {
				rows: response?.data,
				count: response?.meta?.count,
			};
		});
	};
export const updatePodStatus =
	({ id, status, rejection_reason, trip_id }) =>
	async () => {
		const data = {
			id,
			status,
		};

		// Add rejection_reason and trip_id only when rejecting
		if (status === 'Rejected' && rejection_reason) {
			data.rejection_reason = rejection_reason;
		}
		if (status === 'Rejected' && trip_id) {
			data.trip_id = trip_id;
		}
		const isV2UI = getUIVersion() === 'new';
		const CREDENTIALS = {
			url: '/update',
			data: {
				update_type: 'proof_of_delivery',
				data,
			},
			version: isV2UI ? 'v2' : 'v1',
		};

		return API.common(CREDENTIALS);
	};
export const getPodUrl =
	({ limit, offset = 0, currentPage, ...rest }) =>
	async () => {
		const isV2UI = getUIVersion() === 'new';
		const CREDENTIALS = {
			url: '/search',
			// showLoading: false,
			data: {
				search_type: 'proof_of_delivery_url',
				filter_by: {
					id: rest.id,
				},
				limit,
				offset,
			},
			version: isV2UI ? 'v2' : undefined,
		};

		return API.common(CREDENTIALS).then((response) => ({
			rows: response?.data,
			count: response?.meta?.count,
		}));
	};
export const rejectTrip = ({ id, audit_remarks }) => {
	console.log(id);
	console.log({ id });
	const isV2UI = getUIVersion() === 'new';
	const urlType = '/update';
	const CREDENTIALS = {
		url: urlType,
		data: {
			update_type: 'reject_trip',
			data: {
				trip_id: id,
				audit_remarks,
			},
		},
		version: isV2UI ? 'v2' : undefined,
	};

	return API.common(CREDENTIALS).then((res) => {
		console.log(res);
		window.location.reload();
	});
};

export const approvalTrip = ({ id }) => {
	const isV2UI = getUIVersion() === 'new';
	const urlType = '/update';
	console.log(id);
	const CREDENTIALS = {
		url: urlType,
		data: {
			update_type: 'approve_trip',
			data: {
				trip_id: id,
			},
		},
		version: isV2UI ? 'v2' : undefined,
	};

	return API.common(CREDENTIALS).then((res) => {
		console.log(res);
		window.location.reload();
	});
};

/**
 * Accept Vendor Bill Changes V1
 * @param {Object} params
 * @param {number} params.audit_id - Audit ID (required)
 * @returns {Promise} API response
 */
export const acceptVendorBillChangesV1 =
	({ audit_id }) =>
	async () => {
		if (!audit_id) {
			return { success: false, error: 'Audit ID is required' };
		}

		const CREDENTIALS = {
			url: '/update',
			data: {
				update_type: 'vendor_bill_changes_accept',
				data: {
					audit_id,
				},
			},
			version: undefined, // v1
		};

		try {
			const response = await API.common(CREDENTIALS);
			if (response.status === 'success') {
				return { success: true, data: response.data };
			}
			const errorMessage =
				response?.error?.message ||
				response?.message ||
				'Failed to accept vendor bill changes';
			return { success: false, error: errorMessage };
		} catch (error) {
			const errorMessage =
				error?.response?.data?.message ||
				error.message ||
				'Failed to accept vendor bill changes';
			return { success: false, error: errorMessage };
		}
	};

/**
 * Reject Vendor Bill Changes V1
 * @param {Object} params
 * @param {number} params.audit_id - Audit ID (required)
 * @param {string} params.reason - Optional rejection reason
 * @returns {Promise} API response
 */
export const rejectVendorBillChangesV1 =
	({ audit_id, reason }) =>
	async () => {
		if (!audit_id) {
			return { success: false, error: 'Audit ID is required' };
		}

		const CREDENTIALS = {
			url: '/update',
			data: {
				update_type: 'vendor_bill_changes_reject',
				data: {
					audit_id,
					...(reason ? { reason } : {}),
				},
			},
			version: undefined, // v1
		};

		try {
			const response = await API.common(CREDENTIALS);
			if (response.status === 'success') {
				return { success: true, data: response.data };
			}
			const errorMessage =
				response?.error?.message ||
				response?.message ||
				'Failed to reject vendor bill changes';
			return { success: false, error: errorMessage };
		} catch (error) {
			const errorMessage =
				error?.response?.data?.message ||
				error.message ||
				'Failed to reject vendor bill changes';
			return { success: false, error: errorMessage };
		}
	};

/**
 * Search Invoice Edit Approvals V1
 * Uses vendor_field_changes_list search_type for v1 API
 * @param {Object} params
 * @param {string} params.status - Status filter (pending, approved, rejected)
 * @param {number} params.limit - Limit for pagination
 * @param {number} params.offset - Offset for pagination
 * @returns {Promise} API response
 */
export const searchInvoiceEditApprovalsV1 =
	({ status = 'pending', limit = 20, offset = 0 }) =>
	async () => {
		// Map status to API format: pending -> pending, approved -> accepted, rejected -> rejected
		const apiStatus = status === 'approved' ? 'accepted' : status;

		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type: 'vendor_field_changes_list',
				filter_by: {
					status: apiStatus,
				},
				limit,
				offset,
			},
			version: undefined, // v1 API - no version means v1
		};

		return API.common(CREDENTIALS).then((response) => {
			// Transform response to match expected format
			if (response.status === 'success') {
				// Transform v1 response to match component expectations
				const approvals = (response.data || []).map((item) => ({
					id: item.id,
					audit_id: item.id, // Use id as audit_id for v1
					entity_id: item.vendor_bill_id,
					vendor_bill_id: item.vendor_bill_id, // Include vendor_bill_id directly
					approval_type: 'vendor_bill_changes',
					status: item.status === 'accepted' ? 'approved' : item.status, // Map accepted back to approved
					created_at: item.created_at,
					requested_at: item.created_at,
					updated_at: item.updated_at, // Include updated_at for approved/rejected dates
					updated_by: item.updated_by, // Include updated_by user ID
					updated_by_username: item.updated_by_username, // Include updated_by_username for approved_by/rejected_by
					entity_summary: {
						vendor_bill_no: item.invoice_no,
						vendor_name: item.vendor_name,
						project_name: item.project_name || '',
						initial_invoice_value: item.initial_invoice_value,
						updated_invoice_value: item.updated_invoice_value,
						billing_period: item.billing_period,
					},
					// Also include direct fields for backward compatibility
					invoice_no: item.invoice_no, // Include invoice_no directly
					vendor_bill_no: item.invoice_no,
					vendor_name: item.vendor_name,
					project_name: item.project_name || '',
					initial_invoice_value: item.initial_invoice_value,
					updated_invoice_value: item.updated_invoice_value,
					billing_period: item.billing_period,
				}));

				return {
					approvals,
					pagination: {
						page: Math.floor(offset / limit) + 1,
						per_page: limit,
						total: response.meta?.count || 0,
					},
				};
			}
			return {
				approvals: [],
				pagination: {
					page: Math.floor(offset / limit) + 1,
					per_page: limit,
					total: 0,
				},
			};
		});
	};

/**
 * Get Invoice Edit Approval Details V1
 * Uses vendor_field_changes_list search_type with vendor_bill_id filter
 * @param {Object} params
 * @param {number} params.vendor_bill_id - Vendor bill ID (required)
 * @returns {Promise} API response with approval details including changes and image_keys
 */
export const getInvoiceEditApprovalDetailsV1 =
	({ vendor_bill_id }) =>
	async () => {
		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type: 'vendor_field_changes_list',
				filter_by: {
					vendor_bill_id,
				},
				limit: 50,
				offset: 0,
			},
			version: undefined, // v1 API - no version means v1
		};

		return API.common(CREDENTIALS).then((response) => {
			if (response.status === 'success') {
				// Return the first item from the data array (should be the pending approval)
				const approvalData = response.data?.[0] || null;
				return {
					status: 'success',
					data: approvalData,
				};
			}
			return {
				status: 'error',
				message: response.message || 'Failed to fetch approval details',
			};
		});
	};

/**
 * Get Vendor Bill Field Changes History V1 (Audit Trail)
 * Uses vendor_bill_field_changes search_type
 * @param {Object} params
 * @param {number} params.vendor_bill_id - Vendor bill ID (required)
 * @param {string} params.status - Optional filter by status (pending, accepted, rejected)
 * @param {Object} params.pagination - Optional pagination { page, per_page }
 * @returns {Promise} API response with audit history
 */
export const getVendorBillFieldChangesHistoryV1 =
	({ vendor_bill_id, status, pagination = { page: 1, per_page: 20 } }) =>
	async () => {
		const filterBy = {
			id: vendor_bill_id,
		};

		if (status) {
			filterBy.status = status;
		}

		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type: 'vendor_bill_field_changes',
				filter_by: filterBy,
				pagination: {
					page: pagination.page || 1,
					per_page: pagination.per_page || 20,
				},
			},
			version: undefined, // v1 API - no version means v1
		};

		return API.common(CREDENTIALS).then((response) => {
			if (response.status === 'success') {
				return {
					status: 'success',
					data: response.data || [],
					meta: response.meta || { count: 0 },
				};
			}
			return {
				status: 'error',
				message: response.message || 'Failed to fetch edit history',
				data: [],
				meta: { count: 0 },
			};
		});
	};

export const POR_DOC_ENTITY = 'trip';

export const getPoRList =
	({ limit = 50, offset = 0, ...filters }) =>
	async () => {
		const filter_by = { limit, offset };
		Object.entries(filters).forEach(([key, value]) => {
			if (value !== undefined && value !== null && value !== '') {
				filter_by[key] = value;
			}
		});
		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type: 'search_por_approvals',
				filter_by,
			},
			version: 'v2',
		};
		return API.common(CREDENTIALS).then((response) => ({
			rows: response?.data || [],
			count: response?.meta?.count || 0,
		}));
	};

export const handlePoRApproval =
	({ por_id, action, comments, rejection_reason }) =>
	async () => {
		const data = { por_id, action };
		if (action === 'approve' && comments) {
			data.comments = comments;
		}
		if (action === 'reject') {
			data.rejection_reason = rejection_reason;
		}
		const CREDENTIALS = {
			url: '/update',
			data: {
				update_type: 'handle_por_approval',
				data,
			},
			version: 'v2',
		};
		return API.common(CREDENTIALS);
	};

export const reuploadPoR =
	({ trip_id, document_key }) =>
	async () => {
		const CREDENTIALS = {
			url: '/update',
			data: {
				update_type: 'reupload_por',
				data: { trip_id, document_key },
			},
			version: 'v2',
		};
		return API.common(CREDENTIALS);
	};

export default approvalSlice.reducer;
